import React, { useEffect } from "react";

const ProductSchemaMarkup = ({ productData }) => {
  useEffect(() => {
    if (!productData) return;

    const productUrl = `https://parishaudio.com/products/${productData.productURI}`;
    const imageUrl = productData.images?.[0]?.URI
      ? `https://parishaudio.com${productData.images[0].URI}`
      : undefined;

    const downloadUrls = [
      productData.windowsDownloadURI
        ? `https://parishaudio.com${productData.windowsDownloadURI}`
        : null,
      productData.macDownloadURI
        ? `https://parishaudio.com${productData.macDownloadURI}`
        : null,
    ].filter(Boolean);

    const schemaData = {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: productData.name,
      applicationCategory: "MultimediaApplication",
      operatingSystem: "Windows, macOS",
      softwareVersion: productData.productVersion || "1.0",
      description: productData.shortDescription,
      sku: productData.SKU,
      url: productUrl,
      author: {
        "@type": "Person",
        name: "Nate Parish",
      },
      publisher: {
        "@type": "Organization",
        name: "Parish Audio",
        url: "https://parishaudio.com",
      },
      brand: {
        "@type": "Brand",
        name: "Parish Audio",
      },
      offers: {
        "@type": "Offer",
        price: Number(productData.price || 0).toFixed(2),
        priceCurrency: "USD",
        availability: "https://schema.org/InStock",
        url: productUrl,
      },
      aggregateRating:
        Number(productData.ratingCount) > 0
          ? {
              "@type": "AggregateRating",
              ratingValue: String(productData.starRating),
              reviewCount: String(productData.ratingCount),
            }
          : undefined,
      image: imageUrl
        ? {
            "@type": "ImageObject",
            url: imageUrl,
            caption: productData.images?.[0]?.altText || productData.name,
          }
        : undefined,
      downloadUrl: downloadUrls.length > 0 ? downloadUrls : undefined,
    };

    const cleanedSchemaData = JSON.parse(JSON.stringify(schemaData));

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.innerHTML = JSON.stringify(cleanedSchemaData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [productData]);

  return null;
};

export default ProductSchemaMarkup;

// import React, { useEffect } from "react";

// const ProductSchemaMarkup = ({ productData }) => {
//   useEffect(() => {
//     if (!productData) return;

//     const schemaData = {
//       "@context": "https://schema.org",
//       "@type": "SoftwareApplication",
//       "name": productData.name,
//       "applicationCategory": "MultimediaApplication",
//       "operatingSystem": "Windows, macOS",
//       "softwareVersion": productData.versionDownloads?.[0] || "0.1",
//       "description": productData.shortDescription,
//       "alternateName": productData.SKU,
//       "author": "Nate Parish",
//       "publisher": {
//         "@type": "Organization",
//         "name": "Parish Audio",
//         "url": "https://parishaudio.com/products/" + productData.productURI
//       },
//       "offers": {
//         "@type": "Offer",
//         "price": "0.00",
//         "priceCurrency": "USD",
//         "availability": "https://schema.org/InStock",
//         "url": productData.productURI,
//       },
//       "aggregateRating": productData.starRating
//         ? {
//             "@type": "AggregateRating",
//             "ratingValue": productData.starRating.toString(),
//             "reviewCount": productData.ratingCount.toString(),
//           }
//         : undefined,
//       "image": {
//         "@type": "ImageObject",
//         "url": "https://parishaudio.com" + productData.images?.[0]?.URI || "",
//         "caption": productData.images?.[0]?.altText || productData.name
//       }
//     };

//     // Remove undefined values to keep schema clean
//     const cleanedSchemaData = JSON.parse(JSON.stringify(schemaData));

//     const script = document.createElement("script");
//     script.type = "application/ld+json";
//     script.innerHTML = JSON.stringify(cleanedSchemaData);
//     document.head.appendChild(script);

//     return () => {
//       document.head.removeChild(script);
//     };
//   }, [productData]);

//   return null;
// };

// export default ProductSchemaMarkup;


// // import React, { useEffect } from "react";

// // const ProductSchemaMarkup = ({ productData }) => {
// //   useEffect(() => {
// //     if (!productData) return;

// //     const schemaData = {
// //       "@context": "https://schema.org",
// //       "@type": "SoftwareApplication",
// //       "name": productData.name,
// //       "applicationCategory": "MultimediaApplication",
// //       "operatingSystem": "Windows, macOS",
// //       "softwareVersion": productData.versionDownloads?.[0] || "1.0",
// //       "image": productData.imageURIs?.[0] || "",
// //       "description": productData.shortDescription,
// //       "offers": {
// //         "@type": "Offer",
// //         "price": "0.00",
// //         "priceCurrency": "USD",
// //         "availability": "https://schema.org/InStock",
// //         "url": productData.productURI,
// //       },
// //       "downloadUrl": [
// //         productData.windowsDownloadURI,
// //         productData.macDownloadURI
// //       ].filter(Boolean),
// //       "aggregateRating": productData.starRating
// //         ? {
// //             "@type": "AggregateRating",
// //             "ratingValue": productData.starRating.toString(),
// //             "reviewCount": productData.ratingCount.toString(),
// //           }
// //         : undefined,
// //     };

// //     // Remove undefined values to keep schema clean
// //     const cleanedSchemaData = JSON.parse(JSON.stringify(schemaData));

// //     const script = document.createElement("script");
// //     script.type = "application/ld+json";
// //     script.innerHTML = JSON.stringify(cleanedSchemaData);
// //     document.head.appendChild(script);

// //     return () => {
// //       document.head.removeChild(script);
// //       console.log(script.innerHTML)
// //     };
// //   }, [productData]);

// //   return null;
// // };

// // export default ProductSchemaMarkup;
